import { MantineTheme, rem } from '@mantine/core';
import { H2Medium } from 'theme/typography';
import { TABLET_BREAKPOINT } from 'theme/components/utils/tablet';

/** Shared modal and drawer header spacing, typography, and close control. */
export function getOverlayHeaderStyles(theme: MantineTheme) {
  return {
    header: {
      paddingTop: rem(24),
      paddingRight: rem(24),
      paddingLeft: rem(24),
      paddingBottom: rem(12),
      [theme.fn.smallerThan(TABLET_BREAKPOINT)]: {
        paddingTop: rem(16),
        paddingRight: rem(16),
        paddingLeft: rem(16),
        paddingBottom: rem(8),
      },
    },
    title: {
      ...H2Medium,
    },
    close: {
      color: theme.colors.gray[7],
      padding: rem(0),
      svg: {
        width: rem(24),
        height: rem(24),
      },
    },
  };
}
